import { apiClient } from './client'

export type ReportDefinition = {
  title: string
  dataset: string
  columns: string[]
  filters: { field: string; operator: string; value: string | null }[]
  sortBy: string
  sortDirection: 'asc' | 'desc'
}
export type AdminReport = {
  id: string
  definition: ReportDefinition
  environment: string
  createdAt: string
}
export type ReportMessage = { role: 'user' | 'assistant'; content: string }
export type ReportCatalog = {
  environment: string
  isConfigured: boolean
  datasets: Record<string, { id: string; label: string; type: string }[]>
}
export type ReportResult = {
  environment: string
  asOf: string
  page: number
  pageSize: number
  total: number
  rows: Record<string, string | number | boolean | null>[]
}
export const getReportCatalog = async (signal?: AbortSignal) =>
  (await apiClient.get<ReportCatalog>('/api/admin/reports/catalog', { signal })).data
export const listAdminReports = async (signal?: AbortSignal) =>
  (await apiClient.get<AdminReport[]>('/api/admin/reports', { signal })).data
export const getAdminReport = async (id: string, signal?: AbortSignal) =>
  (await apiClient.get<AdminReport>(`/api/admin/reports/${encodeURIComponent(id)}`, { signal })).data
export const runAdminReport = async (id: string, page: number, asOf?: string, signal?: AbortSignal) =>
  (await apiClient.get<ReportResult>(`/api/admin/reports/${encodeURIComponent(id)}/results`, {
    params: { page, asOf }, signal
  })).data
export const askAdminReports = async (
  prompt: string, history: ReportMessage[], currentReportId?: string, signal?: AbortSignal
) => (await apiClient.post<{ type: 'report' | 'clarify' | 'unsupported'; message: string; report: AdminReport | null }>(
  '/api/admin/reports/assistant', { prompt, history, currentReportId }, { signal }
)).data
